var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgNeutral(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 40 40",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "task-b",
    width: 24,
    height: 32,
    x: 8,
    y: 4,
    rx: 1
  }), /*#__PURE__*/React.createElement("filter", {
    id: "task-a",
    width: "116.7%",
    height: "112.5%",
    x: "-8.3%",
    y: "-3.1%",
    filterUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dy: 1,
    in: "SourceAlpha",
    result: "shadowOffsetOuter1"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    in: "shadowOffsetOuter1",
    result: "shadowBlurOuter1",
    stdDeviation: 0.5
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "shadowBlurOuter1",
    result: "shadowMatrixOuter1",
    values: "0 0 0 0 0.127109646   0 0 0 0 0.0591805127   0 0 0 0 0.197180707  0 0 0 0.16 0"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 1,
    in: "SourceAlpha",
    result: "shadowOffsetOuter2"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    in: "shadowOffsetOuter2",
    result: "shadowBlurOuter2",
    stdDeviation: 0.5
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "shadowBlurOuter2",
    result: "shadowMatrixOuter2",
    values: "0 0 0 0 0.125490196   0 0 0 0 0.0588235294   0 0 0 0 0.196078431  0 0 0 0.12 0"
  }), /*#__PURE__*/React.createElement("feMerge", null, /*#__PURE__*/React.createElement("feMergeNode", {
    in: "shadowMatrixOuter1"
  }), /*#__PURE__*/React.createElement("feMergeNode", {
    in: "shadowMatrixOuter2"
  }))))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40
  }), /*#__PURE__*/React.createElement("use", {
    fill: "#000",
    filter: "url(#task-a)",
    xlinkHref: "#task-b"
  }), /*#__PURE__*/React.createElement("use", {
    fill: "#FBF9F6",
    xlinkHref: "#task-b"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#9E9FB1",
    d: "M22 24C22.5522847 24 23 24.4477153 23 25L23 26C23 26.5522847 22.5522847 27 22 27L17 27C16.4477153 27 16 26.5522847 16 26L16 25C16 24.4477153 16.4477153 24 17 24L22 24zM27 18C27.5522847 18 28 18.4477153 28 19L28 20C28 20.5522847 27.5522847 21 27 21L17 21C16.4477153 21 16 20.5522847 16 20L16 19C16 18.4477153 16.4477153 18 17 18L27 18zM27 12C27.5522847 12 28 12.4477153 28 13L28 14C28 14.5522847 27.5522847 15 27 15L17 15C16.4477153 15 16 14.5522847 16 14L16 13C16 12.4477153 16.4477153 12 17 12L27 12zM14 24C14.5522847 24 15 24.4477153 15 25L15 26C15 26.5522847 14.5522847 27 14 27L13 27C12.4477153 27 12 26.5522847 12 26L12 25C12 24.4477153 12.4477153 24 13 24L14 24zM14 18C14.5522847 18 15 18.4477153 15 19L15 20C15 20.5522847 14.5522847 21 14 21L13 21C12.4477153 21 12 20.5522847 12 20L12 19C12 18.4477153 12.4477153 18 13 18L14 18zM14 12C14.5522847 12 15 12.4477153 15 13L15 14C15 14.5522847 14.5522847 15 14 15L13 15C12.4477153 15 12 14.5522847 12 14L12 13C12 12.4477153 12.4477153 12 13 12L14 12z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNeutral);
export default __webpack_public_path__ + "static/media/neutral.cf02aacb59ac13fbbfc6733b0a76735f.svg";
export { ForwardRef as ReactComponent };